<template lang="pug">
v-dialog(
  scrollable
  v-model="dialog"
  dark
  width="450px"
)
  v-card(outlined)
    v-card-title
      h3 Создание новой задачи
    v-card-text
      v-form(v-model="valid")
        v-text-field(
          v-model="form.name"
          label="Введите название задачи"
          :rules="[rules.required]"
          filled
        )

        v-textarea(
          label="Введите описание задачи"
          v-model="form.description"
          :rules="[rules.required]"
          filled
        )

        select-my-user(
          v-model="addUser"
          label="Назначьте исполнителя"
          :rules="[rules.required]"
          filled
          return-object
        )

        date-time-picker(
          v-model="form.notify_at"
          label="Укажите дату и в время завершения задачи"
          filled
        )

        v-slider(
          v-model="form.advance_notify_day"
          :label="`Напомнить исполнителю о необходимости выполнения за ${form.advance_notify_day} дней`"
          thumb-label="always"
          step="1"
          max="7"
          color="primary"
        )

      v-card.pa-4.mb-2.d-flex(
        style="overflow-x:auto"
        outlined
      )
        Uploader(@upload="files.push($event)")
          template(#activator)
              v-btn.mr-4(color="success" height="80px" width="80px")
                v-icon mdi-plus
        p(v-if="files.length === 0").caption Допускается прикрепление текстовых файлов pdf, doc, docx, excel, изображений img, png. Максимальный размер для каждого файла 5 мб
        Element(
          v-for="(file, index) in files"
          :key="index"
          :url="file.url"
          show-actions
          :name="file.original_name || file.name"
          @delete="files.splice(index, 1)"
        )
    v-card-actions
      v-btn.mr-4(
        color="success"
        @click="createNewTask"
        :disabled="!valid"
      ) Сохранить
      v-btn(@click="closeDialog" color="primary") Отменить
</template>
<script>
import DateTimePicker from '@/components/DateTimePicker.vue';
import rules from '@/lib/rules';
import { isImage } from '@/lib';
import Element from '@/components/icons/Element.vue';
import Uploader from '@/components/core/Uploader.vue';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import taskServices, { CRUDTasks } from '@/services/API/task';
import { mapGetters } from 'vuex';
import mixinDateTime from '@/mixins/mixinDateTime';

const DEFAULT_FORM = {
  status: 1,
  name: '',
  description: '',
  users: [],
  owner_id: null,
  documents: [],
  images: [],
  is_favorite: false,
  notify_at: false,
  advance_notify_day: 1,
};

export default {
  components: {
    SelectMyUser,
    Element,
    Uploader,
    DateTimePicker,
  },
  mixins: [mixinDateTime],
  props: {
    value: { type: Boolean, required: true },
    parentId: { type: Number, required: false, default: null },
  },
  data() {
    return {
      valid: false,
      dialog: false,
      form: { ...DEFAULT_FORM },
      files: [],
      rules,
      addUser: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.dialog = v;
      },
    },
    dialog(v) {
      this.$emit('close', v);
    },
  },
  methods: {
    async createNewTask() {
      try {
        const params = { ...this.form };

        const files = this.files.map(({ file_name }) => file_name);
        params.images = files.filter((file) => isImage(file.url));
        params.documents = files.filter((file) => !isImage(file.url));
        params.notify_at = this.parseDate(new Date(this.form.notify_at));

        params.parent_id = this.parentId;

        params.owner_id = this.user.id;

        const response = await CRUDTasks.create(params);
        this.$emit('addNewTask', { ...params, ...response.data.data });
        await this.attachUser(response.data.data.id);
        this.$toast.success('Задача успешно создана');

        this.closeDialog();
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    async attachUser(id) {
      try {
        await taskServices.attachUser(id, [this.addUser.id]);
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.form = { ...DEFAULT_FORM };
    },
  },
};
</script>
<style scoped></style>
